module.exports = __webpack_public_path__ + "static/media/26.8883fcde.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/26.jpg
// module id = 485
// module chunks = 0